<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click="closePopup">
        <div class="bg-white" @click="($event) => $event.stopPropagation()">
          <Vue3Lottie :animationData="SuccessJSON" :height="100" :width="100" />
          <h2>Reserva canjeada</h2>
          <p>Has canjeado la reserva correctamente</p>
          <button @click="acceptPopup" class="main_button" style="width: 100%; margin-top: 10px;">Aceptar</button>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps } from 'vue';
  import { Vue3Lottie } from 'vue3-lottie'
  import SuccessJSON from '@/assets/anim/success_animation.json'

  // Define las props del componente para recibir el mensaje de error
  const props = defineProps({
    redeemSuccessVisible: Boolean
  });

  const visible = ref(false);
  
  // Hacer visible el popup cuando haya un mensaje de error
  watch(() => props.redeemSuccessVisible, (newVal) => {
    visible.value = !!newVal;
  });
  
  const acceptPopup = () => {
    visible.value = false;
  };

  const closePopup = () => {
    visible.value = false;
  };
</script>
  
  <style scoped>
  /* Estilo de transición para suavizar la aparición/desaparición del popup */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  /* Fondo translúcido detrás del popup */
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 50; /* Asegura que el popup esté sobre el contenido */
  }
  
  /* Estilo de la caja que contiene el error */
  .bg-white {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 80%; /* Puedes ajustar el ancho de la caja */
    max-width: 600px; /* Ajusta el tamaño máximo */
    text-align: center;
  }
  
  </style>
  